class ComparisonTable {
    constructor(element) {
        this.table = element;
        this.title = this.table?.querySelector(".js-compare-block-title");
        this.body = this.table?.querySelector(".js-compare-block-body");

        this._init();
    }

    _init() {
        this.title.addEventListener("click", () => {
            this._toggleTitleActiveClass();
            this._toggleBodyHiddenClass();
        });
    }

    _toggleTitleActiveClass() {
        this.title.classList.toggle("active");
    }

    _toggleBodyHiddenClass() {
        this.body.classList.toggle("hidden");
    }
}

const compareTableBlock = document.querySelectorAll(".js-compare-table-block");

if (compareTableBlock) {
    window.addEventListener("load", () => {
        compareTableBlock.forEach((block) => new ComparisonTable(block));
    });
}
